import { render } from "./ManageTemplateModal.vue?vue&type=template&id=8a937cd0&ts=true"
import script from "./ManageTemplateModal.vue?vue&type=script&lang=ts"
export * from "./ManageTemplateModal.vue?vue&type=script&lang=ts"

import "./ManageTemplateModal.vue?vue&type=style&index=0&id=8a937cd0&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__